import React from 'react';
import Button from '../../../../../components/Common/Button';
import Uploader from '../../Uploader';

interface ImageUploadSectionProps {
  handleImageChange: (e: File) => void;
  setPreviewImage: React.Dispatch<React.SetStateAction<string>>;
  setShouldCoverPortrait: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedImage: React.Dispatch<React.SetStateAction<string>>;
  setContinueWithoutImage: React.Dispatch<React.SetStateAction<boolean>>;
}

const ImageUploadSection: React.FC<ImageUploadSectionProps> = ({
                                                                 handleImageChange,
                                                                 setPreviewImage,
                                                                 setShouldCoverPortrait,
                                                                 setSelectedImage,
                                                                 setContinueWithoutImage
                                                               }) => {
  return (
    <div
      className="w-full lg:w-[46%] mt-10 flex flex-col justify-center items-center gap-2">
      <Uploader
        onFileChange={handleImageChange}
        setPreviewImage={setPreviewImage}
        setShouldCoverPortrait={setShouldCoverPortrait}
      />
      <p>Or</p>
      <Button
        title={'Continue Without Uploading Photo'}
        className="bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-sm "
        onClick={() => {
          setSelectedImage('./Image holder Icon.png');
          setContinueWithoutImage(true);
        }}
        tooltip="I will describe My Character"
      />
    </div>
  );
};

export default ImageUploadSection;
